export default __webpack_public_path__ + "static/media/upload_outline.94d22f38.svg";